import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { getDocumentsFilterSchema } from '../components/DocumentsFilter/helpers/getDocumentsFilterSchema';
import { clientDocumentsRoute } from '../route';

const documentsFilterSchema = getDocumentsFilterSchema();

export const clientBankDocumentsRoute = createRoute({
	path: '/bank',
	getParentRoute: () => clientDocumentsRoute,
	component: lazyRouteComponent(
		() => import('./ClientBankDocumentsPage'),
		'ClientBankDocumentsPage',
	),
	validateSearch: z.object({
		openedBankDocument: z.string().optional(),
		pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
		loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
		filter: documentsFilterSchema.catch({}),
	}),
});
